import Vue from 'vue'
Vue.directive("minFullHeight", {
	inserted: function(el) {
		el.style.minHeight = window.innerHeight + "px";
	},
	bind: function(el) {
		window.onresize = function() {
			el.style.minHeight = window.innerHeight + "px";
		}
	}
})
Vue.directive("fullHeight", {
	inserted: function(el) {
		el.style.height = window.innerHeight + "px";
	},
	bind: function(el) {
		window.onresize = function() {
			el.style.height = window.innerHeight + "px";
		}
	}
})
